import { MAAnalysisTooltipDTO } from "@models/managed-accounts/entities/step/fee";
import { SHStack, SHTypography } from "@components/design-systems";
import { NumericFormat } from "react-number-format";
import { useTheme } from "@mui/material";
import { WarningSVG } from "@components/svgs";
import { WarningButtonV2 } from "@components/buttons/warning-v2";

type AnalysisFeePortfolioWarningIconProps = {
  type: "warning" | "error";
  warningData?: {
    title: string | null;
    tooltip?: MAAnalysisTooltipDTO | null;
  }[];
};

export const AnalysisFeePortfolioWarningIcon = ({
  type,
  warningData,
}: AnalysisFeePortfolioWarningIconProps) => {
  const { palette } = useTheme();

  const renderTitle = (title?: string | null) => {
    if (!title) return null;

    return (
      <SHTypography variant="subtitle1" fontSize={13}>
        {title}
      </SHTypography>
    );
  };

  const renderTooltipContent = (tooltip?: MAAnalysisTooltipDTO | null) => {
    if (!tooltip) return null;

    return (
      <ul style={{ margin: 0, padding: "5px 0 0 15px" }}>
        {tooltip?.data.map((data, index) => (
          <li key={index}>
            <SHStack flexDirection={"row"} justifyContent={"space-between"}>
              <SHTypography variant="body2" marginRight={"20px"} fontSize={13}>
                {data.name}
              </SHTypography>
              <SHTypography
                variant="body2"
                color={palette.error.main}
                fontSize={13}
                whiteSpace={"nowrap"}
              >
                <NumericFormat
                  displayType="text"
                  value={Math.abs(parseFloat(data.value))}
                  thousandSeparator=","
                  prefix={parseFloat(data.value) < 0 ? "-$" : "$"}
                  color={palette.error.main}
                />
              </SHTypography>
            </SHStack>
          </li>
        ))}
      </ul>
    );
  };

  const getWarningData = () => {
    if (!warningData || warningData.length === 0) return [];

    return warningData?.map((data) => ({
      ...data,
      title: renderTitle(data.title),
      tooltip: renderTooltipContent(data.tooltip),
    }));
  };

  return (
    <SHStack
      width={12}
      height={12}
      sx={{
        button: {
          width: 12,
          height: 12,
        },
      }}
    >
      <WarningButtonV2
        warningData={getWarningData()}
        customSVG={
          <WarningSVG
            height={12}
            width={12}
            backgroundColor={
              type === "warning" ? palette.warning["100"] : palette.error.main
            }
            iconColor={palette.common.white}
          />
        }
        margin={0}
        maxWidth="380px"
      />
    </SHStack>
  );
};
